<template>
	<div>
		<ExpensesTabs
			:tab="'Expenses'"
			@tab="onTabChange($event)"			
		/>
		<ListReceipt
			v-if="list_visible"
			:color="color"
			:currencies="currencies"
			@update="list_visible = false"
			@create-claims="onCreateClaims($event)"
		/>
		<UploadReceipt
			v-else 
			:color="color"
			:currencies="currencies"
			:receipts_leave_dialog="receipts_leave_dialog"
			@go-back="list_visible = true"
			@receipts="unsaved_count = $event"
			@change-tab="onChangeTab"
		/>
	</div>
</template>

<script>
import ListReceipt from "@/views/expenses/receipts/list_receipt";
import UploadReceipt from "@/views/expenses/receipts/new_receipt";
import ExpensesTabs from "@/views/expenses/commond/expenses_tabs";

export default {
	name: 'Expenses',
	data() {
		return {
			list_visible: true,
			color: this.$attrs.color ? this.$attrs.color : '#FFB946',
			currencies: [],
			tab_tmp: '',
			unsaved_count: 0,
			receipts_leave_dialog: false,
		}
	},
	components: {
		ExpensesTabs,
		ListReceipt,
		UploadReceipt
	},
	created() {
		const path = this.$route.path;
		if (path.includes('desktop')) {
			this.list_visible = false;
		}
		
		this.listCountries();
		this.update_breadcrumb();
	},
	methods: {
		listCountries() {
			const url = `/api/config/country`;

			return axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (data.length !== 0) {
							const currencies_by_id = new Map();

							data.forEach(country => {
								if (!country.currency) return;

								const { currency, ...country_details } = country;
								if (!currencies_by_id.has(currency.id)) {
									currencies_by_id.set(currency.id, Object.assign({}, currency, {
										countries: []
									}));
								}

								currencies_by_id.get(currency.id).countries.push(country_details);
							});

							this.currencies = Array.from(currencies_by_id.values());
						}
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		onTabChange(current_tab) {
			if (this.unsaved_count > 0) {
				this.receipts_leave_dialog = true;
				this.tab_tmp = current_tab;
			} else {
				this.receipts_leave_dialog = false;
				this.$router.push({ name: current_tab });
			}
		},
		onChangeTab() {
			this.list_visible = true;
			if (this.tab_tmp.length !== 0) {
				this.$router.push({ name: this.tab_tmp });
			}
		},
		onCreateClaims(receipt_ids) {
			const params_str = receipt_ids.join('&');
			this.$router.push({ name: 'New Claim', query: { ids: params_str } });
		},
		update_breadcrumb() {
			// add this page to our breadcrumbs
			this.$store.commit("push_breadcrumb", {
				exact: true,
				text: 'Expenses',
				to: '/expenses'
			});
		},
	},
}
</script>

